export default __webpack_public_path__ + "assets/southossetia-flag.png";